import { render } from "./CentralMonitoringResponseServicePage.vue?vue&type=template&id=83ba8e54"
import script from "./CentralMonitoringResponseServicePage.vue?vue&type=script&lang=js"
export * from "./CentralMonitoringResponseServicePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__